// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';
import { MAP_COLORS_TO_VALUE } from '@atlassian/jira-issue-epic-color/src/common/constants.tsx';
import type { Color } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';

// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ColorPatch = styled.div<{
	color: Color;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>((props) => ({
	width: '20px',
	height: '20px',
	borderRadius: token('radius.small'),
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: MAP_COLORS_TO_VALUE[props.color],
}));
